import type { Ref } from 'vue';

import { nextTick, ref } from 'vue';

export interface UseNumberFieldComposable {
  isError: Ref<boolean>;
  blinkError: () => void;
  handleKeypress: (event: KeyboardEvent) => void;
}

export default function useNumberField(): UseNumberFieldComposable {
  const isError = ref(false);

  function blinkError(): void {
    isError.value = true;
    void nextTick(() => {
      setTimeout(() => {
        isError.value = false;
      }, 150);
    });
  }

  function handleKeypress(event: KeyboardEvent): void {
    if (event.key === 'Enter') return;
    if (!/\d+/.test(event.key)) {
      blinkError();
      event.preventDefault();
    }
  }

  return {
    isError,
    blinkError,
    handleKeypress,
  };
}
